import React, { useEffect, useState } from 'react';
import backIcon from '../../../imgs/backIcon.svg';
import HomeSidebar from '../homeSidebar/homeSidebar';
import { TipIcon, XIcon } from '../SvgIcons/SvgIcons';
import { Rate } from 'antd';
import { useHistory } from 'react-router-dom';
import { gql, useLazyQuery } from '@apollo/client';
import { GET_COMPLETE_OFFER } from '../../../graphql/query/offers';
import BountyCompleted from './BountyCompleted';

const BountyCardCompleteDetail = () => {
  const [completeOffer, setCompleteOffer] = useState({});
  const history = useHistory();
  const {
    location: {
      state: { myBounty },
    },
  } = history;

  const { id } = myBounty;

  const [getCompleteOffer] = useLazyQuery(gql(GET_COMPLETE_OFFER), {
    fetchPolicy: 'cache-and-network',
    onCompleted: ({ completeOffers }) => setCompleteOffer(completeOffers),
  });

  useEffect(() => {
    getCompleteOffer({
      variables: {
        bountyId: id,
      },
    });
  }, [id]);

  // const { comment, introTime, relation, introPerson: {firstName, lastName, rating} } = completeOffer;

  return (
    <div className="home-container">
      <HomeSidebar></HomeSidebar>
      <div className="home-content bounty-card-details">
        <div className="bounty-completed-top">
          <button className="back-icon" onClick={() => history.goBack()}>
            <img src={backIcon} alt="backIcon" />
            Back
          </button>

          <div className="tip-wrapperes mb-4">
            <div className="pl-3">
              <TipIcon />
            </div>
            <p className="pt-3 pb-3">
              You have 48 hours to report any issue before bounty is released.
            </p>
            <div className="pr-3">
              <XIcon />
            </div>
          </div>
          <BountyCompleted completeOffer={completeOffer} myBounty={myBounty} />
        </div>
      </div>
    </div>
  );
};

export default BountyCardCompleteDetail;
